<template>
  <div class="line-item">
    <div class="text-small">
      <div>
        <span class="text-numbers-tabular pr-1">{{ lineItem.quantity }}</span>
        <span class="pr-1">×</span>
        {{ lineItem.name | truncate }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EssentialsCartLineItem",
  filters: {
    truncate(value) {
      if (!value) return "";
      return value.toString().substring(0, 60);
    },
  },
  props: {
    lineItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.line-item:not(:last-of-type) {
  margin-bottom: $spacer / 4;
}
</style>
